import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MyAccountContainer } from '@components/organisms/MyAccountContainer';
import { MyPersonalData } from '@components/molecules/MyPersonalData';
import { useData } from '@hooks/useData';
import { useGetUser } from '@services/useGetUser';
import { Loader } from '@components/molecules/Pagination';
import { Container } from '@components/atoms/Container';
import styles from './MyProfile.module.css';
import { SITE_URLS } from '@constants';
import { useCustomNavigate } from '@hooks/useCustomNavigate';

export const MyProfile: FC = () => {
    const { t } = useTranslation();
    const { navigate } = useCustomNavigate();
    const { user } = useData();
    const { request: requestUser, loading, error: errorGetUser, lastResponseTime } = useGetUser();

    useEffect(() => {
        requestUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (lastResponseTime) {
            if (errorGetUser) {
                navigate(`/${SITE_URLS.home}`);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastResponseTime]);

    const translations = {
        title: t('my-profile-component.my-account.title'),
    };

    const {
        firstName = '',
        lastName = '',
        photo = '',
        email = '',
        phone = '',
        over18 = false,
        fiscalNumber = '',
        provider = '',
        has2FA = false,
        allowGeolocationTracking = false,
    } = user?.data || {};

    return (
        <MyAccountContainer title={translations.title}>
            {loading ? (
                <div className={styles.loader}>
                    <Loader />
                </div>
            ) : (
                <Container>
                    <MyPersonalData
                        personalData={{
                            firstName,
                            lastName,
                            photo,
                            email,
                            phone,
                            over18,
                            fiscalNumber,
                            provider,
                            has2FA,
                            allowGeolocationTracking,
                        }}
                    />
                </Container>
            )}
        </MyAccountContainer>
    );
};
